<template>
    <div id="app">
        <header class="header" :class="{'header--hidden' : !showNavbar}">
            <div class="header__inner">
                <router-link to="/" class="header__logo" :class="{'is_open' : isOpen}">
                    <svgicon name="dizviz-logo" width="36" height="70"></svgicon>
                </router-link>    

                <button @click="toggleNavigation" class="header__mobile_menu" :class="{'is_open' : isOpen}">
                    <span>menu</span>
                </button>
            </div>

            <div class="navigation" :class="{'is_open' : isOpen}">
                <div class="container">
                    <div class="gr-12">
                        <div class="navigation__wrap" :style="[isOpen ? {'min-height': windowHeight + 'px'} : '']">
                            <div class="navigation__inner" >
                                <div class="navigation__column">
                                    <p class="navigation__overtitle">About</p>
                                    <Menu />
                                </div>

                                <div class="navigation__column">
                                    <p class="navigation__overtitle">For Clients</p>

                                    <ul class="menu__list">
                                        <li class="menu__item">
                                            <router-link to="/login" class="menu__link" data-hover="Login">Login</router-link>
                                        </li>
                                    </ul>
                                </div>

                                <div class="navigation__column hide show@lg">
                                    <div class="meta">
                                        <div class="meta__box">
                                            <h6>Phone</h6>
                                            <p><a href="tel:+385915977043">+385 91 597 7043</a></p>
                                        </div>

                                        <div class="meta__box">
                                            <h6>Email</h6>
                                            <p><a href="mailto:ivica@dizviz.hr">ivica@dizviz.hr</a></p>
                                        </div>

                                        <div class="meta__box">
                                            <h6>Headquarter</h6>
                                            <p>Čret 28</p>
                                            <p>10 000 Zagreb</p>
                                            <p>Croatia</p>
                                        </div>


                                        <div class="meta__box">
                                            <h6>Showroom</h6>
                                            <p>Čret 28</p>
                                            <p>10 000 Zagreb</p>
                                            <p>Croatia</p>
                                        </div>
                                        
                                    </div>
                                </div>
                            </div>
    
                            <div class="navigation__footer">
                                <div class="links">
                                    <router-link to="/">Home</router-link>
                                    <router-link to="/contact">contact</router-link>
                                </div>

                                <div class="social">
                                    <p class="social__description">Follow us on social networks</p>
                                    <ul class="social__list">
                                        <li class="social__item">
                                            <a href="#" class="social__link"><i class="icon-facebook"></i></a>
                                        </li>
                                        <li class="social__item">
                                            <a href="#" class="social__link"><i class="icon-linkedin"></i></a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </header>

        <transition name="overlay-up">
            <router-view />
        </transition>
    </div>
</template>


<script>
// components
import Menu from '@/components/Menu.vue';
import Transition from '@/components/Transition.vue';

//import icons
import '@/compiled-icons/dizviz-logo';
import '@/compiled-icons/facebook';
import '@/compiled-icons/instagram';


export default {
    components: {
        Menu,
        Transition
    },
    data() {
        return {
            showNavbar: true,
            lastScrollPosition: 0,
            isOpen: false,
            windowWidth: 0,
            windowHeight: 0
        };
    },

    mounted() {
        // watch for scroll
        window.addEventListener('scroll', this.onScroll)

        // watch for resizing window
        this.$nextTick(function() {
            window.addEventListener('resize', this.getWindowWidth);
            window.addEventListener('resize', this.getWindowHeight);

            //Init
            this.getWindowWidth()
            this.getWindowHeight()
        })

    },
    methods: {
        toggleNavigation: function () {
          this.isOpen = !this.isOpen;

          if(this.isOpen && window.innerWidth < 1200) {

            // alert('otvoren i širina manja od 1200');
          }
          // else {
          //   alert('ipak baca alert');
          // }
        },

        getWindowWidth() {
            this.windowWidth = document.documentElement.clientWidth;
        },

        getWindowHeight() {
            this.windowHeight = document.documentElement.clientHeight - 80;
        },

        enter(el, done) {
            this.$refs.routerViewRef.enterAnim(done);
        },

        leave(el, done) {
            this.from.leaveAnim(done);
        },

        onScroll() {
            // Get the current scroll position
            const currentScrollPosition = window.pageYOffset || document.documentElement.scrollTop

            // Because of momentum scrolling on mobiles, we shouldn't continue if it is less than zero
            if (currentScrollPosition < 0) {
                return
            }

            // Stop executing this function if the difference between
            // current scroll position and last scroll position is less than some offset
            if (Math.abs(currentScrollPosition - this.lastScrollPosition) < 60) {
                return
            }
            
            // Here we determine whether we need to show or hide the navbar
            this.showNavbar = currentScrollPosition < this.lastScrollPosition

            // Set the current scroll position as the last scroll position
            this.lastScrollPosition = currentScrollPosition
          }
    },
    watch: {
        '$route' () {
            this.isOpen = false
        },

        isOpen() {
            if(this.isOpen){
              document.documentElement.style.overflow = 'hidden'
              return
            }

            document.documentElement.style.overflow = 'auto'
        }
    },
    beforeDestroy() {
        // watch for scroll
        window.removeEventListener('scroll', this.onScroll)
        
        // watch for resizing window
        window.removeEventListener('resize', this.getWindowWidth);
        window.removeEventListener('resize', this.getWindowHeight);
    }
    
};
</script>


<style lang="scss">
    @import "@/scss/modules/_transitions.scss";
</style>